import { ApiPrepaidCardErrorResponse } from "interfaces/ApiPrepaidErrors";

export const errors = [
  {
    code: 'invalid.lot.number',
    description: 'Número de lote invalido, porfavor, intenta nuevamente.'
  },
  {
    code: 'invalid.cardproduct',
    description: 'Producto invalido.'
  },
  {
    code: 'Invalid PAN',
    description: 'Producto invalido por PAN invalido.'
  },
  {
    code: '40017000',
    description: 'Logo invalido, debe estar entre 0 y 4'
  },
  {
    code: 'invalid.realid',
    description: 'Id externo ya existe, porfavor, intenta nuevamente.'
  },
  {
    code: '40001011',
    description: 'Id externo ya existe, porfavor, intenta nuevamente.',
  }
];

export const getErrorMessage = (error: string | undefined) => {
  let textResult = error !== undefined || error ? 'desconocido' : undefined;
  // eslint-disable-next-line array-callback-return
  errors.map( (e) => {
    if(error?.includes(e.code)) {
      textResult = e.description;
    }
  })
  return textResult;
}

export const getPrepaidErrorMessages= (apiErrorResponse: ApiPrepaidCardErrorResponse): string[] => {
  return apiErrorResponse.errors.map((error) => getErrorMessageByCode(String(error.code), error.message));
}

function getErrorMessageByCode(code: string, defaultMessage: string): string {
  const error = errors.find((err) => err.code === code);
  return error ? error.description : defaultMessage;
}